/**
 * pp-cta-guard - stop the mobile sticky bar adding a size nobody chose.
 *
 * Measured on the live PDP at 390x844: the first screen ends at 844px and holds only
 * the image, title, price and review badge. The size control starts at 926px, so it is
 * BELOW the fold, while the sticky Add to cart is on from scroll position zero.
 *
 * A shopper could therefore tap Add to cart having never seen the size control, and
 * land the default variant. On the mat frames that default is "12x36 Mat for 16x40
 * Frame" at $76.99, sitting in the dearest ~18% of that product's sizes. Verified by
 * tapping it on the live page and reading /cart.js back.
 *
 * So: until a size has actually been chosen, the sticky button reads "Choose your size"
 * and takes the shopper to the picker instead of adding anything. Once a size is
 * chosen it becomes an ordinary Add to cart.
 *
 * A ?variant= deep link counts as chosen - that shopper picked their size on the
 * collection page or in an ad.
 */
(function () {
  'use strict';

  function init() {
    var bar = document.getElementById('pp-sticky');
    var btn = document.getElementById('pp-sticky-btn');
    var select = document.querySelector('variant-selects select.select__select');
    if (!bar || !btn || !select || select.options.length < 2) return;
    if (btn.dataset.ppGuard) return;
    btn.dataset.ppGuard = '1';

    var picker = document.querySelector('pp-size-picker');
    var chosen = new URLSearchParams(window.location.search).has('variant');
    var addLabel = btn.textContent.trim() || 'Add to cart';

    function paint() {
      btn.textContent = chosen ? addLabel : 'Choose your size';
    }

    // one hook covers both paths: the picker sets select.value and fires change,
    // and the native select fires change on its own
    select.addEventListener('change', function () {
      if (chosen) return;
      chosen = true;
      paint();
    });
    paint();

    // Capture on the document, NOT on the button. During the at-target phase a
    // listener's capture flag is ignored and registration order wins, and the sticky
    // block's own click handler is inline so it always registers first. Capturing at
    // the document runs strictly earlier.
    document.addEventListener(
      'click',
      function (e) {
        if (chosen || !btn.contains(e.target)) return;
        e.preventDefault();
        e.stopPropagation();

        var target = picker || select.closest('.product-form__input') || select;
        try {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (err) {
          target.scrollIntoView();
        }
        target.classList.add('pp-cta-flash');
        setTimeout(function () {
          target.classList.remove('pp-cta-flash');
        }, 1500);

        var input = picker && picker.querySelector('.pp-sp__input');
        if (input) setTimeout(function () { input.focus(); }, 450);

        try {
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'pp_size_prompt', { source: 'sticky_cta' });
          }
        } catch (err) {
          /* analytics must never break the buy box */
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // the sticky block moves itself to <body> on load, so re-check once it has settled
  setTimeout(init, 800);
})();
